import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import { DisplayTransport } from '../../../../types/models';

// TD1-10482 (M4, PRD D-29/D-32): the "Drop off / Pick Up" table rows of the React print pages
// (Rental Summary, Pick List), one row per stop of rental.displayTransports — label from the API
// ("Drop Off 1", "Pick Up 2"…), rendered like the schedule-derived rows they replace: "No Preference"
// when the schedule says so, a single date/time for a point-in-time stop, start "Through" end otherwise.
//
// react-intl v2 types `value` as Date though it accepts — and internally converts — the ISO strings
// the API sends, which is what every caller here passes; hence the cast.
const renderDateTime = (value: Date | string, timeZone?: string) => (
  <div>
    <FormattedDate
      weekday='short'
      month='short'
      day='numeric'
      year='numeric'
      value={value as Date}
    />{' '}
    <FormattedTime value={value as Date} timeZone={timeZone} timeZoneName='short' />
  </div>
);

// Either shape a print page holds: the REST display payload (snake-cased delivery block) or the
// GraphQL rental.
interface UniformStopsRental {
  delivery?: { delivery_type?: string | null } | null;
  deliveryType?: string | null;
  displayTransports?: DisplayTransport[] | null;
}

export const usesUniformStops = (rental?: UniformStopsRental | null) => {
  const stops = rental?.displayTransports;

  return (
    ['default_delivery', 'custom_delivery'].includes(
      rental?.delivery?.delivery_type ?? rental?.deliveryType ?? ''
    ) &&
    Array.isArray(stops) &&
    stops.length > 0
  );
};

interface PrintStopRowsProps {
  displayTransports: DisplayTransport[];
  timeZone?: string;
}

const PrintStopRows = ({ displayTransports, timeZone }: PrintStopRowsProps) =>
  displayTransports.map((stop, index) => (
    <tr
      className='top'
      key={`${stop.transportType}-${stop.startDateTime}-${index}`}
    >
      <td>{stop.label}</td>
      <td>
        {stop.noPreference ? (
          <div>No Preference</div>
        ) : (
          renderDateTime(stop.startDateTime, timeZone)
        )}
        {(stop.noPreference || stop.hasDeliveryWindow) && (
          <>
            <div className='caption'>Through</div>
            {stop.noPreference ? (
              <div>No Preference</div>
            ) : (
              renderDateTime(stop.endDateTime, timeZone)
            )}
          </>
        )}
      </td>
    </tr>
  ));

export default PrintStopRows;
